import React, { ReactElement } from 'react';
import PanelWidgetConfiguration from 'adapter/in/dashboards/pages/EditDashboard/WidgetMenu/Panel/Configuration';
import { FormProvider } from 'react-hook-form';
import useSideMenuFormContainer from 'adapter/in/dashboards/containers/EditDashboard/WidgetMenu/Panel/Configuration/Tabs/Common/useSideMenuFormContainer';

const PanelWidgetConfigurationContainer = (): ReactElement => {
    const {
        form,
        tab,
        fields,
        options,
        isLoading,
        error,
        errorAction,
        isTabWithError,
        presetName,
        featureName,
    } = useSideMenuFormContainer();

    return (
        /* eslint-disable react/jsx-props-no-spreading */
        <FormProvider {...form}>
            <PanelWidgetConfiguration
                selectedTab={tab}
                fields={fields}
                options={options}
                isLoading={isLoading}
                error={error}
                errorAction={errorAction}
                isTabWithError={isTabWithError}
                featurePresetText={`${featureName} - ${presetName}`}
            />
        </FormProvider>
    );
};

export default PanelWidgetConfigurationContainer;
